import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateTime } from 'luxon';

@Component({
	selector: 'evaluation-answer-card',
	templateUrl: 'evaluation-answer-card.component.html',
	styleUrls: ['evaluation-answer-card.component.scss'],
})
export class EvaluationAnswerCardComponent {
	@Input() title;
	@Input() date;
	@Input() instruments = [];
	@Output() openDetail = new EventEmitter();

	formatedDate(date) {
		let weekDay = DateTime.fromISO(date).setLocale('pt-br').toFormat('ccc');
		weekDay = weekDay.charAt(0).toUpperCase() + weekDay.slice(1);
		weekDay = weekDay.substring(0, weekDay.length - 1);
		return (
			weekDay +
			DateTime.fromISO(date).setLocale('pt-br').toFormat(", dd 'de' LLLL, T")
		);
	}
}
